import { EventOrders, ParsedEventOrders } from './types';
import { format } from 'date-fns';

const parse = (item: any) =>
  Object.freeze({
    isRequest: true,
    orderId: item!.id || '',
    status: item!.state || '',
    img:
      item.event && item.event.image && item.event.image.url
        ? {
            small: item.event.image.url,
          }
        : { small: '' },
    title: item.program_name ? item.program_name : '',
    date: item.date_created ? format(item.date_created, 'DD.MM.YYYY') : '',
    fio: item.client_fio ? item.client_fio : '',
    eventId: item!.event_id || '',
    userCanCancel: item.user_can_cancel,
    id: item!.event_id || '',
    message:
      item.state_reason === '3' && item.state_reason_comment
        ? item.state_reason_comment
        : '',
  });

export const parseEventOrders = (data: EventOrders): ParsedEventOrders =>
  data.map(parse);



// WEBPACK FOOTER //
// ./src/services/api/event-orders/utils/parseEventOrders.ts